const initialState = {
  dossier: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "DOSSIER_SELECT":
      return {
        ...state,
        dossier: action.payload,
      };
    default:
      return state;
  }
}
